import React from 'react';
import {Empty, Spin} from "antd";

interface LoadingProps {
    message:string,
    size:string,
    loadIcon?:React.ReactNode,
}


function LoadingContainer(props:LoadingProps)
{
    const {loadIcon} = props;
    if(props.size === "big" || props.size === "BIG")
    {
        return (

            <div style={{
                width:'100%',
                height:'100%',
                overflow:'hidden',
                position:'fixed',
                top:'0',
                right:'0',
                bottom:'0',
                left:'0',
                backgroundColor:'rgba(255,255,255,0.8)',
                zIndex:'100',
                textAlign:'center',
            }}>
                {loadIcon ? (
                    <div
                        style={{ marginTop: "145px", height: 100, whiteSpace : 'pre-wrap'}}
                    >
                        {loadIcon}
                        <div
                            style={{marginTop : "10px"}}
                        >{props.message}</div>
                    </div>

                ) : (
                    <Empty
                        style={{ marginTop: "145px" }}
                        image="/image/loading/loading.svg"
                        imageStyle={{ height: 100 }}
                        description={<span>{props.message}</span>}
                    />
                )}
            </div>

        );
    }

    return (
        <Spin tip={props.message} size="large"/>
    );

}

LoadingContainer.defaultProps = {
    message:"로딩 중..",
    size:"big",
};

export default LoadingContainer;
